<template>
  <div class="editUserWrap">
    <el-form
      :model="userForm"
      status-icon
      ref="userForm"
      label-width="120px"
      class="userForm"
      :rules="userFormRules"
    >
      <p class="quota-edit-intro">
        {{ $tt("只改这个账号自己能带多少工程、多少页配置上限、多少存储（MB）。不改形态套餐，也不限制按钮。") }}
      </p>
      <el-form-item
        v-for="f in eidtableFormItems"
        :key="f.prop"
        :label="$tt(f.label)"
        :prop="f.prop"
      >
        <el-input v-model="userForm[f.prop]" :placeholder="$tt(f.placeholder)"></el-input>
        <div class="field-hint">{{ $tt(f.hint) }}</div>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm()">{{ $tt("保存用量") }}</el-button>
        <el-button @click="$router.push('/userManage/users')">{{ $tt("取消") }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userForm: {},
      userInfo: {},
      eidtableFormItems: [
        {
          prop: "projects",
          label: "工程数量",
          placeholder: "例如 2",
          hint: "该用户云端最多能拥有几个工程",
        },
        {
          prop: "pages",
          label: "页面个数",
          placeholder: "例如 1",
          hint: "账号配置的页面个数，可按用户单独加大",
        },
        {
          prop: "free_capacity",
          label: "免费容量（M）",
          placeholder: "例如 10",
          hint: "私有素材存储上限，单位 MB",
        },
      ],
      userFormRules: {
        projects: [
          { required: true, message: `请输入工程数量`, trigger: "blur" },
        ],
        pages: [{ required: true, message: `请输入页面个数`, trigger: "blur" }],
        free_capacity: [
          { required: true, message: `请输入免费容量`, trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      this.$request.queryUserById({ id: this.$route.query.id }).then((res) => {
        if (res.status != "success") {
          this.$message.error(res.msg);
          return;
        }
        this.userInfo = res.data || {};
        this.userForm = {
          free_capacity: res?.data?.free_capacity,
          pages: res?.data?.pages,
          projects: res?.data?.projects,
        };
      });
    },
    submitForm() {
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          this.$request
            .updateUserStatus({
              id: this.$route.query.id,
              projects: Number(this.userForm.projects),
              pages: Number(this.userForm.pages),
              free_capacity: String(this.userForm.free_capacity),
            })
            .then((res) => {
              if (res.status != "success") {
                this.$message.error(res.msg);
                return;
              }
              this.$message.success("用量已更新");
              this.$router.push("/userManage/users");
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang='scss'>
.userForm {
  background-color: #fff;
  padding: 24px 30% 24px 24px;
  .el-form-item__label {
    width: 30% !important;
  }
  .el-form-item__content {
    margin-left: 30% !important;
    .el-select {
      display: block;
    }
  }
}
.quota-edit-intro {
  margin: 0 0 16px;
  color: #909399;
  font-size: 13px;
  line-height: 1.5;
}
.field-hint {
  margin-top: 4px;
  color: #c0c4cc;
  font-size: 12px;
  line-height: 1.4;
}
</style>
